import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { formatDate } from "../../../../../../functions/dateTime/formatDate";
import { Calendar } from "lucide-react";
import useClickOutside from "../../../../../../CustomHooks/useClickOutside";
import { isHydroExpired } from "../../../../config/isHydroExpired";

const HydroDateInput = ({ value = "", setValue }) => {
  const [showDatePicker, serShowDatePicker] = useState(-1);
  const { dropdownRef } = useClickOutside(() => serShowDatePicker(-1));
  const jobCardData = useSelector((state) => state.jobCard.data);
  const existHydroDate = jobCardData.cylinder.hydroTestingDate;
  const checkExpired = isHydroExpired(existHydroDate);

  const handleShowDatePicker = () => {
    serShowDatePicker((prevIndex) => (prevIndex === 1 ? -1 : 1));
  };

  const today = new Date();
  const startDate = new Date(2020, 0, 1);

  // set last hydro testing date if Hydro Testing Date  Exist or Updated
  useEffect(() => {
    if (existHydroDate) {
      setValue(existHydroDate);
    }
  }, [existHydroDate]);

  return (
    <>
      <div className="relative w-full" ref={dropdownRef}>
        <div
          onClick={handleShowDatePicker}
          className={`border-bw max-w-[200px] relative rounded-md cursor-pointer py-[3px] px-2 focus-input border-lg4`}
        >
          <span className="text-sm font-poppins  pr-5 bg-white">
            {value ? formatDate(value) : "Select Date"}
          </span>
          <Calendar color="gray" className="absolute right-1 top-[3px] w-4" />
        </div>

        {showDatePicker === 1 && (
          <div className="shadow-sh-1 border-1 rounded-md max-w-xs absolute left-0 top-9 bg-white z-9999">
            <DayPicker
              mode="single"
              captionLayout="dropdown"
              fromYear={2020}
              toYear={today.getFullYear()}
              fromDate={startDate}
              selected={value ? new Date(value) : undefined}
              disabled={{
                before: startDate,
                after: today,
              }}
              onSelect={(date) => {
                if (date) {
                  setValue(date.toLocaleDateString("en-CA"));
                }
              }}
              defaultMonth={today}
              classNames={{
                caption_label:
                  "font-bold font-poppins flex items-center mr-3 mb-2",
                head_row: "flex font-medium text-gray-900",
                head_cell: "w-7 font-normal text-sm",
                row: "flex w-full",
                cell: "text-gray-600 rounded-md h-7 w-7 text-center text-sm p-0",
                day: "h-7 w-7 p-0 font-normal",
                day_range_end: "day-range-end",
                day_selected:
                  "rounded-md text-white hover:bg-gray-900 hover:text-white focus:bg-gray-900 focus:text-white",
              }}
            />
          </div>
        )}
      </div>
      {checkExpired && (
        <p className="text-xs text-red-600 pt-2">
          ⓘ Hydro Testing Date is Expired !
        </p>
      )}
    </>
  );
};

export default HydroDateInput;
